import { useState } from "react";
export const TextWrap = ({ location, link = false }) => {
  const [showFull, setShowFull] = useState(false);
  // Split location into words
  const words = location?.split(" ") || [];
  const shortText = words.slice(0, 5).join(" ");
  const isLong = words.length > 5;
  return (
    
      <span
        className={`text-md mb-0 fw-normal text-secondary-light ${
          link && "text-primary-600 cursor-pointer"
        }`}
      >
        {showFull || !isLong ? location : shortText + "..."}
        {isLong && (
          <button
            onClick={() => setShowFull(!showFull)}
            className="show-more-btn"
            aria-label={showFull ? "Show less " : "Show more "}
          >
            {showFull ? "See less" : "See more"}
          </button>
        )}
      </span>
    
  );
};